import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const FourDivineBeasts = () => (
  <StaticQuery
    query=
      {graphql`
        query {
          bg: file(relativePath: { eq: "games/four-divine-beasts.png" }) {
            childImageSharp {
              fluid(maxWidth: 1200) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `}
    render={data => (
      <div className="game-banner">
        {data.bg.childImageSharp.fluid &&
          <Img alt="Four Divine Beasts" fluid={data.bg.childImageSharp.fluid}/>
        }
      </div>
    )}
  />
);

export default FourDivineBeasts;